import React from "react";
import gradient from '../../images/gradient-1.png';
import classNames from 'classnames';

const styles = (height) => ({
  root: {
    height,
    width: '100%',
    background: `url(${gradient})`,
    backgroundSize: '100%',
  }
});

const Divider = ({ height = 4, className }) => (
  <div className={classNames(className, "divider")} style={styles(height).root} />
);

export default React.memo(Divider);